/*
 * @Author: xinxinfeng 2273234784@qq.com
 * @Date: 2024-07-01 14:11:23
 * @LastEditors: xinxinfeng 2273234784@qq.com
 * @LastEditTime: 2025-07-29 14:25:06
 * @FilePath: \crane-safety-manager\src\Layouts\SidebarLayout.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import { CandlestickChart, Anchor, ChevronLeft, ChevronRight, MapPinned, Gauge, LayoutList, UserSquare, Antenna } from 'lucide-react';

import { StyleSimpleBar, StyledCollapsedButton, StyleBrandLogo, StyleSider } from '../Common/SidebarStyle';
import withRouter from '../Common/withRouter';
import { themecolor } from '../config.js';

import BrandLogo from '../assets/images/logo-dark.png';
import BrandlightLogo from '../assets/images/logo-light.png';
import BrandSmLogo from '../assets/images/logo-sm.png';
import * as HPermission from '../helpers/permission_helper';

const SidebarLayout = ({ theme }) => {
    const user = useSelector(state => state.Login.user);

    /**
     * 菜单列表
     */
    const [menuItems, setMenuItems] = useState([]);
    useEffect(() => {
        const role = user?.user?.role;
        // const items = [getItem(<Link to="/">首页</Link>, 'dashboard-vehicles', <Gauge size={16} />),
        //     getItem(<Link to="/dashboard/projects">数据统计</Link>, 'dashboard-projects', <CandlestickChart size={16} />)];
        const items = [getItem(<Link to="/">首页</Link>, 'dashboard-vehicles', <Gauge size={16} />)];
        if (HPermission.hasPermission(role, HPermission.PROJECTS_VIEW)) {
            items.push(getItem(<Link to="/projects">项目管理</Link>, 'projects', <LayoutList size={16} />));
        }
        if (HPermission.hasPermission(role, HPermission.SITES_VIEW)) {
            items.push(getItem(<Link to="/sites">工地管理</Link>, 'sites', <MapPinned size={16} />));
        }
        if (HPermission.hasPermission(role, HPermission.VEHICLES_VIEW)) {
            items.push(getItem(<Link to="/vehicles">车辆管理</Link>, 'vehicles', <Anchor size={16} />));
        }
        if (HPermission.hasPermission(role, HPermission.USERS_VIEW)) {
            items.push(getItem(<Link to="/users">用户管理</Link>, 'users', <UserSquare size={16} />));
        }
        // if (HPermission.hasPermission(role, HPermission.POLES_VIEW)) {
        //     items.push(getItem(<Link to="/poles">监测杆管理</Link>, 'poles', <Anchor size={16} />));
        // }
        // if (HPermission.hasPermission(role, HPermission.ALARM_LOG_VIEW)) {
        //     items.push(getItem(<Link to="/alarm-logs">侵限报警</Link>, 'alarm-logs', <Antenna size={16} />));
        // }
        setMenuItems(items);
    }, [user]);

    function getItem(label, key, icon, children, type) {
        return { key, icon, children, label, type };
    }

    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
        const antHeaderMain = document.getElementById('antHeaderMain');
        if (antHeaderMain) {
            antHeaderMain.style.left = !collapsed ? '100px' : '260px';
        }
        const antLayoutContent = document.getElementById('antLayoutContent');
        if (antLayoutContent) {
            antLayoutContent.style.marginLeft = !collapsed ? '100px' : '260px';
        }
        const antFooterLayout = document.getElementById('antFooterLayout');
        if (antFooterLayout) {
            antFooterLayout.style.marginLeft = !collapsed ? '100px' : '260px';
        }
    };

    const location = useLocation();
    const [activatedItem, setActivatedItem] = useState('home');

    useEffect(() => {
        const currentPath = location.pathname.replace('/', '');
        setActivatedItem(currentPath || 'home');
    }, [location]);

    const toggleActivation = key => {
        setActivatedItem(prevActivatedItem => (prevActivatedItem === key ? null : key));
    };

    return (
        <React.Fragment>
            <StyleSider id="sidebar-layout" width={themecolor.components.Menu.verticalSidebarWidth} collapsed={collapsed} collapsedWidth="100" breakpoint="lg">
                <StyleBrandLogo className="demo-logo ant-mx-auto">
                    <img alt="Brand logo" src={theme === 'dark' ? BrandlightLogo : BrandLogo} width={215} style={{ lineHeight: '24px', objectFit: 'contain' }} className="brand-dark-logo ant-mx-auto" />
                    <img alt="Brand sm logo" src={BrandSmLogo} height={24} style={{ lineHeight: '24px' }} className="brand-sm-logo ant-mx-auto" />
                    <StyledCollapsedButton themecolor={themecolor} type="link" onClick={toggleCollapsed}>
                        {collapsed ? <ChevronRight /> : <ChevronLeft />}
                    </StyledCollapsedButton>
                </StyleBrandLogo>
                <div>
                    <StyleSimpleBar>
                        <Menu selectedKeys={[activatedItem]} mode="inline" theme="light" items={menuItems} collapsedWidth="100" onClick={({ key }) => toggleActivation(key)}></Menu>
                    </StyleSimpleBar>
                </div>
            </StyleSider>
        </React.Fragment>
    );
};

export default withRouter(SidebarLayout);
